import React, { useEffect, useRef } from 'react';
import { motion, useInView, animate } from 'framer-motion';
function Counter({
  from,
  to,
  suffix = '',
  duration = 2
}: {
  from: number;
  to: number;
  suffix?: string;
  duration?: number;
}) {
  const nodeRef = useRef<HTMLSpanElement>(null);
  const inView = useInView(nodeRef, {
    once: true,
    margin: '-50px'
  });
  useEffect(() => {
    if (inView && nodeRef.current) {
      const controls = animate(from, to, {
        duration,
        ease: 'easeOut',
        onUpdate(value) {
          if (nodeRef.current) {
            nodeRef.current.textContent = Math.round(value) + suffix;
          }
        }
      });
      return () => controls.stop();
    }
  }, [inView, from, to, suffix, duration]);
  return <span ref={nodeRef} data-id="element-333">
      {from}
      {suffix}
    </span>;
}
export function TruckLogistics() {
  return <section className="py-32 px-4 w-full bg-gray-50 relative overflow-hidden" data-id="element-334">
      {/* Teal Accents */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[300px] bg-teal-accent/5 blur-[120px] pointer-events-none" data-id="element-335" />

      <div className="max-w-7xl mx-auto" data-id="element-336">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-337">
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col items-start" data-id="element-338">
            <div className="flex gap-3 mb-6" data-id="element-339">
              <span className="px-3 py-1 rounded-full border border-teal-accent/30 text-teal-accent text-sm font-medium" data-id="element-340">
                Truck2Park
              </span>
              <span className="px-3 py-1 rounded-full border border-teal-accent/30 text-teal-accent text-sm font-medium" data-id="element-341">
                Premium Parken
              </span>
            </div>

            <h2 className="text-5xl md:text-6xl font-heading font-bold mb-6 text-gray-900" data-id="element-342">
              Logistik &<br data-id="element-343" />
              LKW Parken
            </h2>
            <p className="text-xl text-gray-500 mb-8 font-body leading-relaxed" data-id="element-344">
              Sicher, komfortabel und perfekt angebunden. Unser Rastpark bietet
              optimale Bedingungen für Berufskraftfahrer. Reservierbare und
              überwachte Parkplätze garantieren eine ruhige Nacht.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-345">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="glass-card p-8 rounded-3xl border-teal-accent/20 flex flex-col items-center justify-center text-center" data-id="element-346">
              <div className="text-5xl font-heading font-bold text-teal-accent mb-2" data-id="element-347">
                <Counter from={0} to={100} suffix="+" data-id="element-348" />
              </div>
              <div className="text-gray-500 font-medium" data-id="element-349">LKW Stellplätze</div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="glass-card p-8 rounded-3xl border-teal-accent/20 flex flex-col items-center justify-center text-center" data-id="element-350">
              <div className="text-5xl font-heading font-bold text-teal-accent mb-2" data-id="element-351">
                24/7
              </div>
              <div className="text-gray-500 font-medium" data-id="element-352">Geöffnet</div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="glass-card p-8 rounded-3xl border-teal-accent/20 flex flex-col items-center justify-center text-center sm:col-span-2" data-id="element-353">
              <div className="flex items-center justify-center gap-5 mb-3" data-id="element-354">
                <img src="https://cdn.magicpatterns.com/uploads/67bAeTyNrjdaEY6ordpJVd/DKV-Logo.svg.png" alt="DKV" className="h-12 rounded-lg object-contain" data-id="element-355" />
                <div className="w-px h-10 bg-gray-200" data-id="element-356" />
                <img src="https://cdn.magicpatterns.com/uploads/hboVHWhntwKeAH3qde42ij/Union_Tank_Eckstein_logo.svg.png" alt="UTA" className="h-12 object-contain" data-id="element-357" />
              </div>
              <div className="text-gray-500 font-medium" data-id="element-358">Akzeptiert</div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}